import type { WidgetData, WidgetDrillDownParams } from '@app-types';

export const CONTACT_USER_ACTIVATION_WIDGET_KEY = 'contact-user-activation';
export const CONTACT_USER_DIVISION_CHANGES_WIDGET_KEY = 'contact-user-division-changes';

/** The widgets that say so when a period has nothing to show: the Assessment, Meeting and Contact-User widgets. */
export const NO_DATA_NOTICE_WIDGET_KEYS: readonly string[] = [
  'assessments-in-progress',
  'gaps',
  'remediations',
  'expired-processes',
  'contract-manager-stats',
  'assessor-stats',
  'scheduler-stats',
  'meetings-original-rescheduled-cancelled',
  'meetings-scheduled-assessed',
  CONTACT_USER_ACTIVATION_WIDGET_KEY,
  CONTACT_USER_DIVISION_CHANGES_WIDGET_KEY
];

/** Whether a widget says "No data in this period." */
export const showsNoDataNotice = (widgetKey: string): boolean => NO_DATA_NOTICE_WIDGET_KEYS.includes(widgetKey);

const isNonZero = (value: string | number): boolean => typeof value === 'number' && value !== 0;

/**
 * Whether the widget has nothing to show for the period: every KPI is zero or absent, no chart point is above zero,
 * and no table cell holds a number above zero.
 */
export function hasNoData(data: WidgetData): boolean {
  const hasKpi = data.metrics.some((metric) => metric.value !== 0);
  const hasChartPoint = data.chart?.series.some((series) => series.values.some((value) => value !== 0)) ?? false;
  const hasTableNumber = data.table?.rows.some((row) => row.some(isNonZero)) ?? false;
  return !hasKpi && !hasChartPoint && !hasTableNumber;
}

/** The Assessments list showing exactly the Assessments behind a number. */
export const assessmentsListPath = (params: WidgetDrillDownParams): string =>
  `/assessments?${new URLSearchParams(params)}`;
